import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.color.base.c3};
  border-radius: 5px;
  padding: 16px 8px 0px 8px;
  row-gap: 10px;
`

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.base.c9};
`

export const Image = styled.img`
  width: 100%;
  mask: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.3) 30%,
    black 70%
  );
  -webkit-mask: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.3) 30%,
    black 70%
  );
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 12px;
`
